import { render, staticRenderFns } from "./AllergyModal.vue?vue&type=template&id=fa560b4c&scoped=true&"
import script from "./AllergyModal.vue?vue&type=script&lang=js&"
export * from "./AllergyModal.vue?vue&type=script&lang=js&"
import style0 from "./AllergyModal.vue?vue&type=style&index=0&id=fa560b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa560b4c",
  null
  
)

export default component.exports